import { render, staticRenderFns } from "./BlockingQuotes.vue?vue&type=template&id=01e8968b"
import script from "./BlockingQuotes.vue?vue&type=script&lang=js"
export * from "./BlockingQuotes.vue?vue&type=script&lang=js"
import style0 from "./BlockingQuotes.vue?vue&type=style&index=0&id=01e8968b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports